import { render } from "./AppAlertSubscription.vue?vue&type=template&id=dbfdcb04&scoped=true&lang=pug"
import script from "./AppAlertSubscription.vue?vue&type=script&lang=js"
export * from "./AppAlertSubscription.vue?vue&type=script&lang=js"

import "./AppAlertSubscription.vue?vue&type=style&index=0&id=dbfdcb04&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbfdcb04"]])

export default __exports__